import React, { ChangeEvent } from 'react';

import MediaTypography from 'components/MediaTypography';

import GoalsImageSrc from '@common/assets/images/about-me/goals/goals_lg.jpg';

import {
	StyledGoalsCreateButton,
	StyledGoalsCreateStepsImg,
	StyledGoalsCreateStepsPaper,
} from '../styled';
import { StyledCreateGoalsStep1TextField, StyledCreateGoalsStep1TextWrap } from './styled';

interface PropsType {
	onClick: () => void;
	onSetMainGoal: (value: string) => void;
	value: string | null;
}

function GoalsCreateStep1({ onClick, onSetMainGoal, value }: PropsType) {
	const handleChange = (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
		onSetMainGoal(event.target.value);
	};
	return (
		<>
			<StyledGoalsCreateStepsPaper>
				<StyledGoalsCreateStepsImg alt="create goal step 1" src={GoalsImageSrc} />
				<StyledCreateGoalsStep1TextWrap>
					<MediaTypography
						variant="h3"
						variants={{ sm: 'h4' }}
						textColor="secondary"
						sx={{ textAlign: 'center' }}
					>
						What is your main goal?
					</MediaTypography>
					<StyledCreateGoalsStep1TextField
						fullWidth
						label="Describe your goal in detail"
						variant="standard"
						onChange={handleChange}
						value={value}
						multiline
					/>
				</StyledCreateGoalsStep1TextWrap>
			</StyledGoalsCreateStepsPaper>
			<StyledGoalsCreateButton variant="contained" onClick={onClick} disabled={!value}>
				Continuation
			</StyledGoalsCreateButton>
		</>
	);
}

export default GoalsCreateStep1;
